import { Property } from '@model';
import { randomElement } from '@utils';
import { PropertyListingPrice } from '../../../shop/components/PropertyListingPrice';
import { ProductBadge } from '../../../shop/components/ProductBadge';
import { ListingLocationPin } from '../ListingLocationPin.tsx';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import './FeaturedProperty.scss';
import { useTranslation } from 'react-i18next';

export const FeaturedProperty: FC<Property> = (prop) => {
  const { t } = useTranslation();

  return (
    <div className='col-lg-12'>
      <div className='ltn__product-item'>
        <div className='product-img'>
          <Link to={`/properties/${prop.id}`}>
            <img src={randomElement(prop.mainImages).thumbUrl} alt='#' />
          </Link>
          <ProductBadge floating variant='box' forSale={prop.forSale} />
          <div className='product-img-location-gallery'>
            <div className='product-img-location'>
              <ul>
                <li>
                  <ListingLocationPin subArea={prop.subArea} area={prop.area} />
                </li>
              </ul>
            </div>
            <div className='product-img-gallery'>
              <ul>
                <li>
                  <Link to={`/properties/${prop.id}`}>
                    <i className='fas fa-camera'></i> {prop.mainImages.length}
                  </Link>
                </li>
                <li>
                  <Link to={`/properties/${prop.id}`}>
                    <i className='fas fa-film'></i> 0
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='product-info'>
          <PropertyListingPrice {...prop} />
          <h2 className='product-title'>
            <Link to={`/properties/${prop.id}`}>
              {prop.subCategory}, {prop.area}
            </Link>
          </h2>
          <div className='product-description line-clamp-5'>
            {prop.description}
          </div>
          <ul className='ltn__list-item-2 ltn__list-item-2-before'>
            {prop.rooms && (
              <li>
                <span>
                  {prop.rooms} <i className='flaticon-bed'></i>
                </span>
                {t('roomsSelect.label')}
              </li>
            )}
            {prop.bathrooms && (
              <li>
                <span>
                  {prop.bathrooms} <i className='flaticon-clean'></i>
                </span>
                {t('bathroomsSelect.label')}
              </li>
            )}
            <li>
              <span>
                {prop.sqrMeters}{' '}
                <i className='flaticon-square-shape-design-interface-tool-symbol'></i>
              </span>
              {t('sqrMetersInputs.labelShort')}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
